<script>
import {list as listPatios} from '../../../../domain/patio/services/patio'
import service from '../../../../domain/usuarios/services'

export default {
  name: 'UsuarioPatios',
  props: {
    patiosUsuario: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data () {
    return {
      patios: [],
      patioOptions: [
        {label: 'Habilitado', value: true, class: 'btn-default'},
        {label: 'Desabilitado', value: false, class: 'btn-default'}
      ]
    }
  },
  mounted () {
    this.load(10000, 1, '')
  },
  methods: {
    load (limit, page, filtros) {
      this.data = null
      this.isLoading = true
      listPatios(limit, page, filtros)
        .then((response) => {
          this.isLoading = false
          this.patios = (response.data.result || []).map(patio => {
            patio.ativado = this.patiosUsuario.some(p => p.patio.id === patio.id)
            return patio
          })

          // TODO: paginação?
          /* this.pagination.atualPage = response.patios.offset
          this.pagination.totalPages = response.patios.totalPages
          this.pagination.totalItems = response.patios.total */
        })
        .catch((response) => {
          this.isLoading = false
          console.log(response)
        })
    },
    relacionarUsuarioPatio (index) {
      const patio = this.patios[index]
      const tmp = {true: 'habilitar', false: 'remover'}
      const confirmado = confirm(`Confirmar ${tmp[patio.ativado]} pátio "${patio.nome}" para este usuário?`)
      if (!confirmado) {
        patio.ativado = !patio.ativado
        return
      }
      service.relacionarPatio(this.$route.params.id, patio.id, patio.ativado)
        .then((response) => {
          if (patio.ativado) {
            this.patiosUsuario.push({patio})
          } else {
            const index = this.patiosUsuario.findIndex(p => p.patio.id === patio.id)
            this.patiosUsuario.splice(index, 1)
          }
          console.log(response)
        })
        .catch((response) => {
          window.alert(`Não foi possível adicionar o pátio "${patio.nome}", algum problema ocorreu, tente novamente.`)
          patio.ativado = !patio.ativado
          console.log(response)
        })
    }
  }
}
</script>

<template>
  <!--  <div class="wrapper" v-if="patios.length">-->
    <div class="panel panel-default">
      <div class="table-responsive" style="overflow-y: auto; overflow-x: unset">
        <table class="table table-hover table-striped b-t b-light">
          <thead>
          <tr>
            <th>Código</th>
            <th>Nome</th>
            <th>Ação</th>
          </tr>
          </thead>
          <tbody>
          <!-- FAKE -->
          <tr v-if="!patios.length" v-for="i in [1,2,3]">
            <td class="v-middle">
              <u-fake-loader width="20px" class="m-t"></u-fake-loader>
            </td>
            <td role="button" tabindex="0">
              <u-fake-loader width="40%" class="m-t"></u-fake-loader>
            </td>
            <td role="button" tabindex="0">
              <a class="text-cap custom-link ">
                <u-fake-loader width="100%" class="m-t"></u-fake-loader>
              </a>
            </td>
          </tr>
          <tr v-for="(patio, index) in patios">
            <td role="button" tabindex="0" class="text-center" v-if="patio.codigo">{{patio.codigo}}</td>
            <td role="button" tabindex="0" class="text-red" v-else>Sem código</td>
            <td role="button" tabindex="0"> {{patio.nome}}</td>
            <td role="button" tabindex="0">
              <u-button-group
                @change="relacionarUsuarioPatio(index)"
                class="hidden-print"
                v-model="patio.ativado"
                :options="patioOptions"
              >
              </u-button-group>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
  </div>
</template>

<style scoped>
.text-red {
  color: #e74c3c !important;
  text-align: center;
  font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// UsuarioPatios.vue?fc51d310